import React, { useMemo } from 'react';
import { ScreenContainer, ContentFrame, LayoutContentHeader, LinkButton, Typography, } from '@pinwheel/origami';
import TemplateForm from '../../LinkApiRouter/components/TemplateForm/TemplateForm';
import ModalHeader from '../../components/ModalHeader';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import { usePIIDataContext } from '../../hooks/usePIIDataContext';
function PIITemplateForm(_a) {
    var fieldConfigs = _a.fieldConfigs, contentFrameDataTestId = _a.contentFrameDataTestId, _b = _a.initialValues, initialValues = _b === void 0 ? {} : _b, onSubmit = _a.onSubmit, submitButtonText = _a.submitButtonText, _c = _a.submitButtonEventId, submitButtonEventId = _c === void 0 ? 'TemplateForm-continue' : _c, subtitle = _a.subtitle;
    var goBack = usePIIDataContext().goBack;
    var getLocalizedString = useGetLocalizedString();
    var navigate = useLinkNavigate();
    var SearchManually = useMemo(function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(LinkButton, { "data-testid": "searchGenericPlatform", onClick: function () {
                    navigate('/search/search');
                }, sx: { textDecoration: 'none' } },
                React.createElement(Typography, { color: "light", align: "center", variant: "body" }, getLocalizedString('SEARCH_MANUALLY')))));
    }, [getLocalizedString, navigate]);
    return (React.createElement(ScreenContainer, { "data-testid": "ScreenContainer" },
        React.createElement(ModalHeader, { onBack: goBack }),
        React.createElement(LayoutContentHeader, { title: getLocalizedString('LETS_FIND_YOUR_PAYROLL_ACCOUNT'), subtitle: subtitle }),
        React.createElement(ContentFrame, { "data-testid": contentFrameDataTestId },
            React.createElement(TemplateForm, { fieldConfigs: fieldConfigs, initialValues: initialValues, onSubmit: onSubmit, submitButtonEventId: submitButtonEventId, submitButtonText: submitButtonText, extraControlsBottom: SearchManually }))));
}
export default PIITemplateForm;
